import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d0063dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "header is-flex is-justify-content-space-between sticky-header" }
const _hoisted_6 = { class: "title is-4" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_8 = {
  key: 1,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_9 = {
  key: 2,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_10 = {
  key: 3,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_11 = {
  key: 4,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_12 = {
  key: 5,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_13 = {
  key: 6,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_14 = {
  key: 7,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_15 = { class: "content-body scroll-area" }
const _hoisted_16 = {
  key: 0,
  class: "field is-horizontal is-flex-direction-column-mobile mb-2"
}
const _hoisted_17 = { class: "field-body" }
const _hoisted_18 = { class: "field is-expanded" }
const _hoisted_19 = { class: "control is-expanded" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = {
  key: 1,
  class: "table-container mb-2",
  style: {"max-height":"500px","overflow-y":"auto"}
}
const _hoisted_24 = { class: "table" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = {
  key: 1,
  class: ""
}
const _hoisted_29 = {
  key: 2,
  class: ""
}
const _hoisted_30 = {
  key: 3,
  class: ""
}
const _hoisted_31 = {
  key: 4,
  class: ""
}
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { key: 5 }
const _hoisted_35 = {
  key: 2,
  class: "field is-grouped mb-2"
}
const _hoisted_36 = { class: "field is-horizontal is-flex-direction-column-mobile" }
const _hoisted_37 = { class: "field-body" }
const _hoisted_38 = { class: "field" }
const _hoisted_39 = { class: "control" }
const _hoisted_40 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 3,
  class: "field is-horizontal is-flex-direction-column-mobile mb-2"
}
const _hoisted_43 = { class: "field-label is-normal" }
const _hoisted_44 = { class: "label" }
const _hoisted_45 = { class: "field-body" }
const _hoisted_46 = { class: "control" }
const _hoisted_47 = { class: "field-label is-normal" }
const _hoisted_48 = { class: "label" }
const _hoisted_49 = { class: "field-body" }
const _hoisted_50 = { class: "control" }
const _hoisted_51 = { class: "field-body" }
const _hoisted_52 = { class: "control" }
const _hoisted_53 = {
  key: 4,
  class: "table-container mb-2",
  style: {"max-height":"365px","overflow-y":"auto"}
}
const _hoisted_54 = { class: "table" }
const _hoisted_55 = { class: "" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = { class: "" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = {
  key: 0,
  class: ""
}
const _hoisted_60 = { class: "" }
const _hoisted_61 = { class: "" }
const _hoisted_62 = { class: "" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_64 = {
  key: 7,
  class: "table"
}
const _hoisted_65 = { class: "" }
const _hoisted_66 = { class: "" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_68 = {
  key: 8,
  class: "table"
}
const _hoisted_69 = { class: "" }
const _hoisted_70 = { class: "" }
const _hoisted_71 = { class: "" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_73 = {
  key: 10,
  class: "mb-2"
}
const _hoisted_74 = { class: "field is-horizontal is-flex-direction-column-mobile" }
const _hoisted_75 = { class: "field-body" }
const _hoisted_76 = { class: "control" }
const _hoisted_77 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "field is-horizontal is-flex-direction-column-mobile mt-2" }
const _hoisted_80 = { class: "field-label is-normal" }
const _hoisted_81 = { class: "label" }
const _hoisted_82 = { class: "field-body" }
const _hoisted_83 = { class: "control" }
const _hoisted_84 = { class: "field-label is-normal" }
const _hoisted_85 = { class: "label" }
const _hoisted_86 = { class: "field-body" }
const _hoisted_87 = { class: "control" }
const _hoisted_88 = { class: "field-body" }
const _hoisted_89 = { class: "control" }
const _hoisted_90 = {
  key: 11,
  class: "table-container mb-2",
  style: {"max-height":"410px","overflow-y":"auto"}
}
const _hoisted_91 = { class: "table is-fullwidth" }
const _hoisted_92 = { class: "is-size-7" }
const _hoisted_93 = { class: "header" }
const _hoisted_94 = {
  key: 0,
  class: "title is-5"
}
const _hoisted_95 = { class: "columns" }
const _hoisted_96 = { class: "column" }
const _hoisted_97 = { class: "field" }
const _hoisted_98 = { class: "label" }
const _hoisted_99 = { class: "control" }
const _hoisted_100 = ["placeholder"]
const _hoisted_101 = { class: "column" }
const _hoisted_102 = { class: "field" }
const _hoisted_103 = { class: "label" }
const _hoisted_104 = { class: "control" }
const _hoisted_105 = ["placeholder"]
const _hoisted_106 = { class: "columns" }
const _hoisted_107 = { class: "column" }
const _hoisted_108 = { class: "field" }
const _hoisted_109 = { class: "label" }
const _hoisted_110 = { class: "control" }
const _hoisted_111 = ["placeholder"]
const _hoisted_112 = { class: "column" }
const _hoisted_113 = { class: "field" }
const _hoisted_114 = { class: "label" }
const _hoisted_115 = { class: "control" }
const _hoisted_116 = ["placeholder"]
const _hoisted_117 = {
  key: 0,
  class: "column"
}
const _hoisted_118 = { class: "field" }
const _hoisted_119 = { class: "label" }
const _hoisted_120 = { class: "control" }
const _hoisted_121 = ["placeholder"]
const _hoisted_122 = {
  key: 1,
  class: "column"
}
const _hoisted_123 = { class: "field" }
const _hoisted_124 = { class: "label" }
const _hoisted_125 = { class: "control" }
const _hoisted_126 = ["placeholder"]
const _hoisted_127 = { class: "field is-grouped is-grouped-right" }
const _hoisted_128 = { class: "control" }
const _hoisted_129 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_130 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_UserTableRow = _resolveComponent("UserTableRow")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_MngAppointmentRecordTableRow = _resolveComponent("MngAppointmentRecordTableRow")!
  const _component_AppointmentDataForm = _resolveComponent("AppointmentDataForm")!
  const _component_ProductTableRow = _resolveComponent("ProductTableRow")!
  const _component_AppointmentsAccessCodesTableRow = _resolveComponent("AppointmentsAccessCodesTableRow")!
  const _component_VetsAvailabilityTable = _resolveComponent("VetsAvailabilityTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Management.Mode')), 1),
                (_ctx.getMngMode == 'vets' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.$t('Management.ManageVets')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'managers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString(_ctx.$t('Management.ManageManagers')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'customers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_9, _toDisplayString(_ctx.$t('Management.VisualizeCustomers')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'appointments' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_ctx.$t('Management.VisualizeAppointments')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'products' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_11, _toDisplayString(_ctx.$t('Management.ManageProducts')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'appointments_access_codes' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_12, _toDisplayString(_ctx.$t('Management.VisualizeAppointmentsAccessCodes')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'vets_availability' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_13, _toDisplayString(_ctx.$t('Management.VisualizeVetsAvailability')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'logs' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(_ctx.$t('Management.VisualizeLogs')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (_ctx.getMngMode == 'vets' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button is-primary",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewVet')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'managers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "button is-primary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewManager')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'vets_availability')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "button is-primary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportVetAvailTable && _ctx.exportVetAvailTable(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.ExportToExcel')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.getMngMode == 'customers' && !_ctx.creating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customerNameSearch) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.FilterByName')
                          }, null, 8, _hoisted_20), [
                            [_vModelText, _ctx.customerNameSearch]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "button is-light",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.customerNameSearch = ''))
                          }, _toDisplayString(_ctx.$t('General.ResetFilter')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode != 'appointments' &&
                                                       _ctx.getMngMode != 'products' &&
                                                       _ctx.getMngMode != 'appointments_access_codes' &&
                                                       _ctx.getMngMode != 'vets_availability' &&
                                                       _ctx.getMngMode != 'logs' &&
                                                       !_ctx.creating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("table", _hoisted_24, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('UserData.Id')), 1),
                          (_ctx.getMngMode != 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(_ctx.$t('UserData.Photo')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                          _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                          (_ctx.getMngMode != 'managers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_28, _toDisplayString(_ctx.$t('UserData.Phone')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_29, _toDisplayString(_ctx.$t('CustomerData.Address')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'vets')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_30, _toDisplayString(_ctx.$t('VetData.Specialty')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_31, _toDisplayString(_ctx.$t('CustomerData.VATNumber')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('UserData.Status')), 1),
                          _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('UserData.StatusDate')), 1),
                          (_ctx.getMngMode != 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_34, _toDisplayString(_ctx.$t('General.Operations')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: user.user_id
                          }, [
                            _createVNode(_component_UserTableRow, {
                              "user-data": user,
                              parentShowCustomerData: _ctx.showCustomerData
                            }, null, 8, ["user-data", "parentShowCustomerData"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterVetUserId) = $event)),
                              required: "",
                              class: "select is-fullwidth px-3 is-size-6 mobile-select"
                            }, [
                              _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t('Management.SelectVet')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (vet) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: vet.user_id,
                                  value: vet.user_id
                                }, _toDisplayString(vet.name), 9, _hoisted_41))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.filterVetUserId]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('General.From')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_VueDatePicker, {
                          id: "filter_start_date",
                          modelValue: _ctx.filterStartDate,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterStartDate) = $event)),
                          placeholder: _ctx.$t('General.PleaseSelectDate'),
                          "model-type": "yyyy-MM-dd",
                          "auto-apply": "",
                          "min-date": new Date(1950, 0, 1),
                          "max-date": _ctx.maxDate,
                          "enable-time-picker": false,
                          "prevent-min-max-navigation": "",
                          format: "yyyy-MM-dd"
                        }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('General.To')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_VueDatePicker, {
                          id: "filter_end_date",
                          modelValue: _ctx.filterEndDate,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterEndDate) = $event)),
                          placeholder: _ctx.$t('General.PleaseSelectDate'),
                          "model-type": "yyyy-MM-dd",
                          "auto-apply": "",
                          "min-date": new Date(1950, 0, 1),
                          "max-date": _ctx.maxDate,
                          "enable-time-picker": false,
                          "prevent-min-max-navigation": "",
                          format: "yyyy-MM-dd"
                        }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.ResetFilter')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("table", _hoisted_54, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t('AppointmentData.Appointment')), 1),
                          _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.$t('AppointmentData.Vet')), 1),
                          _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.$t('AppointmentData.Customer')), 1),
                          _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.$t('AppointmentData.Pet')), 1),
                          (_ctx.considerInsurance)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_59, _toDisplayString(_ctx.$t('AppointmentData.Policy')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", _hoisted_60, _toDisplayString(_ctx.$t('AppointmentData.Price')), 1),
                          _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.$t('AppointmentData.Status')), 1),
                          _createElementVNode("th", _hoisted_62, _toDisplayString(_ctx.$t('AppointmentData.StatusTime')), 1),
                          _hoisted_63
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAppointments, (appointment) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: appointment.appointment_id
                          }, [
                            _createVNode(_component_MngAppointmentRecordTableRow, { "appointment-data": appointment }, null, 8, ["appointment-data"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && _ctx.getShowingAppointmentData)
                ? (_openBlock(), _createBlock(_component_AppointmentDataForm, { key: 5 }))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.exportAppointmentsToExcel && _ctx.exportAppointmentsToExcel(...args))),
                    class: "button is-primary"
                  }, _toDisplayString(_ctx.$t('Management.ExportToExcel')), 1))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'products')
                ? (_openBlock(), _createElementBlock("table", _hoisted_64, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('ProductData.Id')), 1),
                        _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.$t('ProductData.Designation')), 1),
                        _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.$t('ProductData.Price')), 1),
                        _hoisted_67
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProducts, (product) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: product.product_id
                        }, [
                          _createVNode(_component_ProductTableRow, { "product-data": product }, null, 8, ["product-data"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.useAppointsAccessCodes && _ctx.getMngMode == 'appointments_access_codes')
                ? (_openBlock(), _createElementBlock("table", _hoisted_68, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.ValidFrom')), 1),
                        _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.ValidTo')), 1),
                        _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.Code')), 1),
                        _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.IncludedAppointments')), 1),
                        _hoisted_72
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAppointmentsAccessCodes, (appointments_access_code) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: appointments_access_code.valid_from
                        }, [
                          _createVNode(_component_AppointmentsAccessCodesTableRow, { "appointments-access-code-data": appointments_access_code }, null, 8, ["appointments-access-code-data"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'vets_availability' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createBlock(_component_VetsAvailabilityTable, {
                    key: 9,
                    ref: "vetAvailTableRef",
                    vetsAvailability: _ctx.getVetsAvailability
                  }, null, 8, ["vetsAvailability"]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'logs')
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterLogEntity) = $event)),
                            class: "select is-fullwidth px-3 is-size-6 mobile-select"
                          }, [
                            _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.$t('Management.SelectEntity')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logEntities, (entity) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: entity,
                                value: entity
                              }, _toDisplayString(entity), 9, _hoisted_78))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.filterLogEntity]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t('General.From')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createVNode(_component_VueDatePicker, {
                            modelValue: _ctx.filterLogStartDate,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterLogStartDate) = $event)),
                            "model-type": "yyyy-MM-dd",
                            "auto-apply": "",
                            "enable-time-picker": false,
                            format: "yyyy-MM-dd"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('General.To')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createVNode(_component_VueDatePicker, {
                            modelValue: _ctx.filterLogEndDate,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterLogEndDate) = $event)),
                            "model-type": "yyyy-MM-dd",
                            "auto-apply": "",
                            "enable-time-picker": false,
                            format: "yyyy-MM-dd"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("button", {
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetLogFilters && _ctx.resetLogFilters(...args))),
                            class: "button is-light"
                          }, _toDisplayString(_ctx.$t('General.ResetFilter')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'logs')
                ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                    _createElementVNode("table", _hoisted_91, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.Date')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.Operation')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.EntityName')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.EntityType')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.EntityId')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.UpdatedByUserName')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.UpdatedByUserId')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('LogsData.Details')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLogs, (log) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: log.log_id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(log.changed_at), 1),
                            _createElementVNode("td", null, _toDisplayString(log.operation_type), 1),
                            _createElementVNode("td", null, _toDisplayString(log._details.name ||
                          '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(log.resource), 1),
                            _createElementVNode("td", null, _toDisplayString(log._details.customer_id ||
                          log._details.user_id ||
                          log._details.pet_id ||
                          '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(log.last_update_user_name), 1),
                            _createElementVNode("td", null, _toDisplayString(log.last_update_user_id), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("pre", _hoisted_92, "                          " + _toDisplayString(JSON.stringify(log._details, null, 2)) + "\n                        ", 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.creating)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 12,
                    onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createUserMeth && _ctx.createUserMeth(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_93, [
                      (_ctx.getMngMode == 'vets')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_94, _toDisplayString(_ctx.$t('Management.NewVet')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                          _createElementVNode("div", _hoisted_99, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 2,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newUser.name) = $event)),
                              class: "input",
                              type: "text",
                              placeholder: _ctx.$t('UserData.NamePlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_100), [
                              [_vModelText, _ctx.newUser.name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                          _createElementVNode("div", _hoisted_104, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newUser.email) = $event)),
                              class: "input",
                              type: "email",
                              placeholder: _ctx.replaceSpecialCharacters(_ctx.$t('UserData.EmailPlaceholder')),
                              required: ""
                            }, null, 8, _hoisted_105), [
                              [_vModelText, _ctx.newUser.email]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('UserData.Password')), 1),
                          _createElementVNode("div", _hoisted_110, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 6,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newUser.password) = $event)),
                              class: "input",
                              type: "password",
                              placeholder: _ctx.$t('UserData.PasswordPlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_111), [
                              [_vModelText, _ctx.newUser.password]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("div", _hoisted_113, [
                          _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t('CustomerData.PassConfirmation')), 1),
                          _createElementVNode("div", _hoisted_115, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 6,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newUser.confirmation) = $event)),
                              class: "input",
                              type: "password",
                              placeholder: _ctx.$t('UserData.PassConfirmationPlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_116), [
                              [_vModelText, _ctx.newUser.confirmation]
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.getMngMode != 'managers')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t('UserData.PhoneNumber')), 1),
                              _createElementVNode("div", _hoisted_120, [
                                _withDirectives(_createElementVNode("input", {
                                  minlength: 6,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newUser.phone) = $event)),
                                  class: "input",
                                  type: "phone",
                                  placeholder: _ctx.$t('UserData.PhoneNumberPlaceholder'),
                                  required: ""
                                }, null, 8, _hoisted_121), [
                                  [_vModelText, _ctx.newUser.phone]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getMngMode == 'vets')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                            _createElementVNode("div", _hoisted_123, [
                              _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t('VetData.Specialty')), 1),
                              _createElementVNode("div", _hoisted_125, [
                                _withDirectives(_createElementVNode("input", {
                                  minlength: 6,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newUser.specialty) = $event)),
                                  class: "input",
                                  type: "test",
                                  placeholder: _ctx.$t('VetData.SpecialtyPlaceholder'),
                                  required: ""
                                }, null, 8, _hoisted_126), [
                                  [_vModelText, _ctx.newUser.specialty]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("p", _hoisted_128, [
                        _createElementVNode("button", _hoisted_129, _toDisplayString(_ctx.$t('General.Save')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_130, [
                        _createElementVNode("a", {
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.toggleCreating && _ctx.toggleCreating(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}